<template>
    <div v-if="essay.observations">

        <div class="h5">
            Comentário Geral

            <span v-b-tooltip.hover title="Aqui está um comentário geral sobre o texto corrigido pelo professor">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                </svg>
            </span>

        </div>

        <b-card v-if="essay" class="mb-3">

            <div class="ql-snow" v-if="essay.observations">
                <div class="ql-editor" v-html="essay.observations"></div>
            </div>

        </b-card>

    </div>
</template>

<script>
export default {
    props: ['essay', 'commentFull']
}
</script>

<style scoped>

</style>
